// ----------------------------------------------------------------------------
// Snippet: Swiper Control
// ----------------------------------------------------------------------------
//
// ----------------------------------------------------------------------------

// -------------------------------------
// Dependencies
// -------------------------------------

// Styles
import './_swiper-controls.scss';